import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaGooglePlay, FaApple } from 'react-icons/fa'; // Importing icons

function Easy() {
    const { t } = useTranslation();

    return (
        <section className="call-to-action bg-blue-600 text-white py-10 px-6 rounded-lg shadow-lg">
            <div className="container text-center">
                <h3 className="call-to-action__title text-3xl font-bold"
                style={
                    {
                        textAlign : "center"
                    }
                }
                >{t('callToAction2.title')}</h3>
                
 
           

                <div className="call-to-action__app-links mt-6 flex justify-center gap-4">
                    <a href="#" className="app-link flex items-center gap-2 bg-gray-800 text-white px-4 py-2 rounded-lg shadow-md hover:bg-gray-700 transition">
                        <FaGooglePlay size={60} />
                        {/* <span className="text-sm">{t('callToAction2.appLinks.googlePlay')}</span> */}
                    </a>
                    {/* <br></br> */}
                    <a href="#" className="app-link flex items-center gap-2 bg-gray-800 text-white px-4 py-2 rounded-lg shadow-md hover:bg-gray-700 transition">
                        <FaApple size={60} />
                        {/* <span className="text-sm">{t('callToAction2.appLinks.appStore')}</span> */}
                    </a>
                </div>
                            
                    <div className="call-to-action__btn-wrap">
                        <a                 href="https://wa.me/212782906714"
 className="thm-btn">
                        {t('callToAction2.buttonText')}
                            <i className="far fa-arrow-alt-circle-right"></i>
                        </a >
                    </div>
            </div>
        </section>
    );
}

export default Easy;
